import { useEffect, useState } from 'react';
import { useServices } from './use-services';

export function useIntentApplications(intentName?: string) {
  const { intentService } = useServices();
  const [applications, setApplications] = useState<string[]>([]);

  useEffect(() => {
    const importApplications = async (intentName: string) => {
      const applications = await intentService.getIntentApplications(intentName);
      setApplications(applications);
    };
    setApplications([]);
    if (intentName) {
      importApplications(intentName);
    }
  }, [intentName]);

  return applications;
}
